import React, { Component } from "react"

import PropTypes from "prop-types";

export default class Paginator extends Component {
    constructor(props){
        super(props)
        this.state = {
            items : props.items,
            page : 1,
            total_pages : Math.ceil(props.items.length/props.itemsPerPage)            
        }       

    }

    componentWillReceiveProps(nextProps){
        this.setState({
            items : nextProps.items,
            page : nextProps.page || 1,       
            total_pages : nextProps.totalPages
        })
    }    

    onClickPageButton = (e) => {        
        this.setState({
            page : Number(e.target.firstChild.nodeValue)            
        }, () => {
            console.log(this.state.page)
            window.scrollTo(0,0)
            const pageChange = this.props.onPageChange || ((page)=>{})
            pageChange(this.state.page)
        })        
    }

    leftClick = () => {
        if(this.state.page > 1){
            this.setState({ page : this.state.page - 1}, () => {
                window.scrollTo(0,0)
                const pageChange = this.props.onPageChange || ((page)=>{})
                pageChange(this.state.page)
            })            
        }
    }

    rightClick = () => {
        if(this.state.page < this.state.total_pages){
            this.setState({ page : this.state.page + 1 }, () => {
                window.scrollTo(0,0)
                const pageChange = this.props.onPageChange || ((page)=>{})
                pageChange(this.state.page)
            })            
        }            
    }

    renderPageButtons = () => {
        let buttons = []       
        const maxButtons = 20
        if(this.state.total_pages > maxButtons){            
            const range = 5
            for(let i = 0; i < this.state.total_pages; i++){
                const distance = Math.abs(this.state.page - (i+ 1))
                // console.log("Distance is ", distance, " for button : ", (i+ 1))
                let style = {
                    background : "none",
                    border : "0px",
                    color : "black"
                }
                                
                if (this.state.page === (i + 1)){                                
                    style.color = "#732165" 
                    style.border = "1px solid #732165"                   
                }     
                
                if(distance > maxButtons){
                    style.display = "none"
                }

                if((i === this.state.total_pages - 1) || (i === 0)){
                    style.display = "inline-block"
                }
                
                if(distance > range && i !== this.state.total_pages - 1 && i !== 0){
                    buttons.push(
                        <button key={i} style={style}>
                            .
                        </button>
                    )
                }
                else{
                    buttons.push(
                        <button key={i} style={style} onClick={this.onClickPageButton}>
                            {i + 1}
                        </button>
                    )
                }
            }     
            
            return buttons
        }
        for(let i = 0; i < this.state.total_pages; i++){            
            let extraClasses = " "                        
            if (this.state.page === (i + 1)){            
                extraClasses += "activePaginatorButton"
            }    
            const classes = "paginatorButton rounded-circle" + extraClasses 
            buttons.push(
            <button key={i} className={classes} onClick={this.onClickPageButton}>
                {i + 1}
            </button>
            )

        }        
        return buttons
    }

    render(){        
        return(
            <div className={"row " + (this.props.paginatorContainerDivClass || "")}>
                <div className="w-100 mt-5 mb-5" hidden={!this.props.loading} style={{display : "inline-grid"}}>
                    <img  className="img-responsive spinner mx-auto" alt="" src="https://wed.lushplans.com/images/logo_color_spinner.gif" />
                </div>
                <div hidden={this.props.loading}>
                    {this.props.renderPage(this.state.items)}
                </div>
                <div className="col-12" hidden={this.state.total_pages <= 1}>
                    {/* Button div */}
                    <div className="center">
                        <button style={{background : "none", border : "0px"}} disabled={this.state.page === 1}
                        onClick={this.leftClick}>
                            <i className="fa fa-caret-left"></i>
                        </button>

                            {this.renderPageButtons()} 

                        <button style={{background : "none", border : "0px"}} disabled={this.state.page === this.state.total_pages}
                        onClick={this.rightClick}>
                            <i className="fa fa-caret-right"></i>
                        </button>              
                    </div>
                </div>
                
            </div>
        )
    }
}

Paginator.propTypes = {
    items : PropTypes.array.isRequired,
    renderPage : PropTypes.func.isRequired,    
    itemContainerDivClass : PropTypes.string,
    paginatorContainerDivClass : PropTypes.string,
    onPageChange : PropTypes.func,
    loading : PropTypes.bool,
    page : PropTypes.number,
    renderNullItemsMessage : PropTypes.any
}



// WEBPACK FOOTER //
// ./src/Components/Paginator.js